export default __webpack_public_path__ + "static/media/mode.1f2e3528.svg";